import { render, staticRenderFns } from "./PreviewMenu.vue?vue&type=template&id=6244e7c2&"
import script from "./PreviewMenu.vue?vue&type=script&lang=ts&"
export * from "./PreviewMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports